import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import blogsData from "./BlogData";

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogsData.find((b) => b.slug === slug);
  const [isReading, setIsReading] = useState(false);
  const [assistantActive, setAssistantActive] = useState(false);
  const [hasGreeted, setHasGreeted] = useState(false);
  const [speechRec, setSpeechRec] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
      if (speechRec) speechRec.stop();
    };
  }, [speechRec]);

  useEffect(() => {
    const items = document.querySelectorAll(".faq-item h3, .faq-item .faq-toggle");
    const handleClick = (e) => e.currentTarget.parentNode.classList.toggle("faq-active");
    items.forEach((faqItem) => faqItem.addEventListener("click", handleClick));
    return () => items.forEach((faqItem) => faqItem.removeEventListener("click", handleClick));
  }, []);

  const techs = [
    { name: "Angular", icon: "bi-code-slash", color: "orange" },
    { name: "React", icon: "bi-lightning-charge", color: "blue" },
    { name: "AWS", icon: "bi-cloud", color: "green" },
    { name: "Docker", icon: "bi-box-seam", color: "red" },
    { name: "Azure", icon: "bi-cloud-arrow-up", color: "purple" },
    { name: "Vue", icon: "bi-diagram-3", color: "teal" },
    { name: "Python", icon: "bi-cpu", color: "yellow" },
    { name: "JavaScript", icon: "bi-braces", color: "pink" },
    { name: "Semantic", icon: "bi-layout-text-window", color: "cyan" },
    { name: "Go Lang", icon: "bi-gear", color: "orange" },
    { name: ".NET", icon: "bi-windows", color: "blue" },
    { name: "PHP", icon: "bi-file-code", color: "green" },
    { name: "NodeJs", icon: "bi-node-plus", color: "red" },
    { name: "CSS 3", icon: "bi-palette", color: "purple" },
    { name: "Bootstrap", icon: "bi-layers", color: "teal" },
    { name: "Big Data", icon: "bi-bar-chart", color: "yellow" },
    { name: "Salesforce", icon: "bi-lightbulb", color: "pink" },
    { name: "DevOps", icon: "bi-gear-wide-connected", color: "cyan" },
    { name: "Workday", icon: "bi-briefcase", color: "orange" },
  ];

  const activateTab = (tabId) => {
    document.querySelectorAll(".tab-pane").forEach((tab) => tab.classList.remove("active", "show"));
    document.querySelectorAll(".nav-link").forEach((link) => link.classList.remove("active", "show"));

    const targetTab = document.getElementById(tabId);
    if (targetTab) targetTab.classList.add("active", "show");
    const navLink = document.querySelector(`a[data-bs-target="#${tabId}"]`);
    if (navLink) navLink.classList.add("active", "show");

    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
  };

  const readText = (elementId) => {
    const element = document.querySelector(elementId);
    if (!element) return;
    const text = element.innerText;
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.8;
    utterance.pitch = 1.0;
    utterance.lang = "en-US";
    utterance.voice =
      window.speechSynthesis
        .getVoices()
        .find((v) => v.lang.includes("en") && v.name.includes("Female")) || null;

    utterance.onboundary = (event) => {
      if (event.charIndex !== undefined) highlightWord(element, text, event.charIndex);
    };

    utterance.onend = () => {
      element.innerText = text;
      setIsReading(false);
    };

    window.speechSynthesis.speak(utterance);
    setIsReading(true);
  };

  const highlightWord = (element, fullText, charIndex) => {
    const before = fullText.slice(0, charIndex);
    const after = fullText.slice(charIndex);
    const words = before.split(/\s+/);
    const currentWord = words[words.length - 1] || "";
    const start = before.lastIndexOf(currentWord);
    const end = start + currentWord.length;

    element.innerHTML =
      fullText.slice(0, start) +
      `<span style="background-color:lightblue;border-radius:3px;">` +
      fullText.slice(start, end) +
      `</span>` +
      fullText.slice(end);
  };

  const speak = (text, onEnd) => {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.9;
    u.pitch = 1.0;
    u.lang = "en-US";
    u.voice =
      window.speechSynthesis
        .getVoices()
        .find((v) => v.lang.includes("en") && v.name.includes("Female")) || null;
    u.onend = onEnd;
    window.speechSynthesis.speak(u);
  };

  const waitUserResponse = (callback) => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Speech recognition not supported in this browser");
      return;
    }
    const recognition = new window.webkitSpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
    recognition.onresult = (event) => callback(event.results[0][0].transcript.toLowerCase());
    recognition.onerror = () => speak("Please say that again.", () => waitUserResponse(callback));
    recognition.start();
    setSpeechRec(recognition);
  };

  const handleFirstResponse = (response) => {
    if (response.includes("fine") || response.includes("good")) {
      speak("Great! Which section do you want to open?", () =>
        waitUserResponse(startListeningForSection)
      );
    } else {
      speak("I’m here to guide you. Which section would you like to open?", () =>
        waitUserResponse(startListeningForSection)
      );
    }
  };

  const startAssistant = () => {
    if (assistantActive) return;
    setAssistantActive(true);
    if (!hasGreeted) {
      speak("Hello! How are you today?", () => waitUserResponse(handleFirstResponse));
      setHasGreeted(true);
    } else {
      speak("Which section would you like to move to?", () =>
        waitUserResponse(startListeningForSection)
      );
    }
  };

  const startListeningForSection = (response = "") => {
    const sections = ["hero", "about", "features", "services", "pricing", "blog", "contact"];
    const match = sections.find((s) => response.includes(s));
    if (match) {
      document.getElementById(match)?.scrollIntoView({ behavior: "smooth" });
      speak(`Here is your ${match} section.`);
    } else {
      speak("I couldn't find that section. Please try again.", () =>
        waitUserResponse(startListeningForSection)
      );
    }
  };

  if (!blog) {
    return (
      <div className="container text-center py-5">
        <h2>Blog not found</h2>
        <Link to="/blogs" className="btn btn-secondary mt-3">
          Back to Blogs
        </Link>
      </div>
    );
  }

  return (
     <div >
    {}
     
<section
  className="section mt-5 contact-hero"
  style={{
    backgroundImage: `url('/assets/img/about-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '60px 0',
    position: 'relative',
    color: '#fff',
    textAlign: 'center',
  }}
>
  {}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1,
    }}
  ></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <nav className="custom-breadcrumbs mb-3">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <a href="/blog">Blog</a>
          <span className="separator">/</span>
             <a href="#">Blog-Details</a>
        </nav>
        <h1 className="display-4 fw-bold">{blog.title}</h1>
        <p className="lead mt-3">
          Reach out to us for web development services, inquiries, or support.
        </p>
      </div>
    </div>
  </div>
</section>

    {}
 <section className="blog-detail section mt-5 py-5">
  <style>
    {`
      .blog-detail-img {
        width: 100%;
        height: 550px;
        object-fit: cover;
        border-radius: 10px;
      }

      @media (max-width: 768px) {
        .blog-detail-img {
          height: 300px;
        }
      }
    `}
  </style>

  <div className="container">
    <h1>Blog Details</h1>

    {/* FIXED IMAGE STYLE */}
    <img
      src={blog.image}
      alt={blog.title}
      className="blog-detail-img rounded mb-5"
    />

    <h2 className="mb-3">{blog.title}</h2>

    <div
      className="blog-content"
      dangerouslySetInnerHTML={{ __html: blog.content }}
    ></div>

    <div className="tech-stack mt-5">
      <h4>Technologies Used:</h4>
      <div className="d-flex flex-wrap">
        {techs.map((tech) => (
          <div
            key={tech.name}
            className="tech-item d-flex align-items-center m-2 p-2 border rounded"
          >
            <i
              className={`bi ${tech.icon} me-2`}
              style={{ color: tech.color, fontSize: "1.5rem" }}
            ></i>
            <span>{tech.name}</span>
          </div>
        ))}
      </div>
    </div>

    <Link to="/#blog" className="btn btn-primary mt-4">
      ← Back to Home
    </Link>
  </div>
</section>


    {}
   
</div>
   
  );
};

export default BlogDetail;
